<template>
  <div class="row">
    <div class="col-12 grid-force-newlines">
      <FormRow label="Contact">
        <Spinner v-if="loading" />
        <FormSearchableSelect v-show="!loading && !loadingError" :options="contactLookup" :value="value" @input="contactUpdated" placeholder="Contact" />
        <span v-if="loadingError" class="text-danger">{{loadingError}}</span>
      </FormRow>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import FormMixin from '@/mixins/form'

export default {
  name: 'ReportContactSelect',
  model: {
    prop: 'value',
    event: 'update'
  },
  mixins: [FormMixin],
  props: {
    value: Number,
  },
  watch: {
    
  },
  data() {
    return {
      loading: true,
      loadingError: '',
      contactLookup: []
    }    
  },
  mounted() {
    this.loading = true
    this.loadingError = ''

    this.$apiService.contactService.getContactList({ isActive: 1 })
    .then(response => {
      let contactList = response.data

      this.contactLookup = [{ value: null, name: 'None' }]
      this.contactLookup = _.concat(this.contactLookup, contactList.map(item => {
        return { value: item.id, name: item.name }
      }))
    })
    .catch(err => {
      this.loadingError = this.processFormResponse(err).errorMessage
    })
    .finally(() => {
      this.loading = false
    })
  },
  methods: {
    contactUpdated(contactId) {
      if(contactId) {
        this.$emit('update', contactId)
        this.$emit('updateName', this.contactLookup.find(contact => contact.value == contactId).name)
      } else {
        this.$emit('update', null)
        this.$emit('updateName', '')
      }
    }
  }
}
</script>